module.exports = __webpack_public_path__ + "static/media/delete-interview.e7041834.png";